import React, { forwardRef } from 'react';
import get from 'lodash/get';

const FormInput = forwardRef(({
    label,
    name,
    errors = {},
    type = "text",
    required = false,
    value,
    defaultValue = "",
    placeholder = "",
    textarea = false,
    maxLengthText = "max length 1000 character",
    disabled = false,
    showHeaderLabel = true,
    validation = {},
    maxLength = 500,
    style = {},
    className = "",
    labelClassName = "",
    wrapperClassName = "mb-3",
    noFormControl = false,
    ...rest
}, ref) => {
    const InputTag = textarea ? "textarea" : "input";
    const errorMessage = get(errors, `${name}.message`);

    return (
        <div className={wrapperClassName}>
            {showHeaderLabel && label && (
                <label className={`form-label fw-bold fs-9 mb-1 text-body-emphasis ${labelClassName}`} htmlFor={name}>
                    {label.replace("Assign", "")} {required && <span className="text-danger">*</span>}
                </label>
            )}
            <InputTag
                id={name}
                ref={ref}
                disabled={disabled}
                type={textarea ? undefined : type}
                className={`${noFormControl ? '' : 'form-control'} ${className} ${textarea ? "textarea-h-130 fs-8-1" : ""}`}
                {...validation}
                {...(value !== undefined ? { value } : { defaultValue })}
                placeholder={placeholder || label}
                maxLength={maxLength}
                style={style}
                {...rest}
            />
            <div className="d-flex justify-content-between mt-1">
                <span>
                    {errorMessage && (
                        <span className="fs-9 fw-bold text-danger">{errorMessage}</span>
                    )}
                </span>
                {maxLengthText && <span className="fs-9 fw-bold text-body-tertiary">{maxLengthText}</span>}
            </div>
        </div>
    );
});

export default FormInput;
